var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2474 12L16.739 8.50842C16.9047 8.343 16.9979 8.11853 16.9981 7.88439C16.9983 7.65025 16.9055 7.42562 16.7401 7.25991C16.5747 7.0942 16.3502 7.00099 16.1161 7.00078C15.8819 7.00057 15.6573 7.09339 15.4916 7.2588L12 10.7504L8.50842 7.2588C8.34271 7.09309 8.11796 7 7.88361 7C7.64926 7 7.42451 7.09309 7.2588 7.2588C7.09309 7.42451 7 7.64926 7 7.88361C7 8.11796 7.09309 8.34271 7.2588 8.50842L10.7504 12L7.2588 15.4916C7.09309 15.6573 7 15.882 7 16.1164C7 16.3507 7.09309 16.5755 7.2588 16.7412C7.42451 16.9069 7.64926 17 7.88361 17C8.11796 17 8.34271 16.9069 8.50842 16.7412L12 13.2496L15.4916 16.7412C15.6573 16.9069 15.882 17 16.1164 17C16.3507 17 16.5755 16.9069 16.7412 16.7412C16.9069 16.5755 17 16.3507 17 16.1164C17 15.882 16.9069 15.6573 16.7412 15.4916L13.2474 12Z",
    fill: "#0C0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.a079bb4190d244cf955875467b480642.svg";
export { ForwardRef as ReactComponent };